import { IconName } from './assets/IconNames';

export const iconNamesArray = Object.values(IconName);
